import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import * as React from 'react'

const BrainCircuitIcon: React.FC<SvgIconProps> = (props) => {
 return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            {/* Lado esquerdo: Estrutura do Cérebro */}
            <path
                d="M12 4.5c-2 0-3.5 1-4.2 2.5C6 6.5 4.5 8 4.5 10c0 1.2.6 2.3 1.5 3-.9.7-1.5 1.8-1.5 3 0 2.2 1.8 4 4 4h3"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {/* Linha central e Conexões (Circuitos) */}
            <path
                d="M12 4.5v15.5M12 8h4M10 12h8M12 16h4"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
            />

            {/* Nós do Circuito (Pontos) */}
            <circle cx="18.5" cy="8" r="1.2" fill="currentColor" />
            <circle cx="20.5" cy="12" r="1.2" fill="currentColor" />
            <circle cx="18.5" cy="16" r="1.2" fill="currentColor" />
        </SvgIcon>
    )
}

export default BrainCircuitIcon